/**
 * Lo que se compro en un pedido, con subtotal, despacho y total. El titulo lo
 * pone la tarjeta que lo contiene (`TarjetaPedido`).
 *
 * Una lista y no una tabla: en el modal no puede haber desplazamiento
 * lateral, y el nombre de un producto puede ser largo. Nombre y precio son
 * los cobrados en su momento (la linea guarda copia); la foto y el enlace a
 * la ficha son los de hoy, y faltan si el producto ya no esta en el catalogo.
 */
import { Link } from 'react-router-dom';

import type { PedidoAdminDetalle } from '@bandu/compartido';

import { textoEntrega } from '../../utilidades/entrega';
import { numero, pesos } from '../../utilidades/formato';
import { rutas } from '../../utilidades/rutas';
import { Imagen } from '../comunes/Imagen';

export interface ItemsPedidoProps {
  pedido: PedidoAdminDetalle;
  volver: string;
}

export function ItemsPedido({ pedido, volver }: ItemsPedidoProps) {
  return (
    <>
      <ul className="items-pedido">
        {pedido.items.map((item) => (
          <li key={item.id} className="item-pedido">
            {item.producto?.imagen ? (
              <Imagen
                className="mini-img"
                src={item.producto.imagen.url}
                alt=""
                ancho={item.producto.imagen.ancho}
                alto={item.producto.imagen.alto}
              />
            ) : (
              <span className="mini-img sin-foto" aria-hidden="true" />
            )}
            <div className="item-pedido-nombre">
              {item.producto !== null ? (
                <Link
                  className="n"
                  to={rutas.administracion.productoDetalle(item.producto.id)}
                  state={{ volver }}
                >
                  {item.nombre}
                </Link>
              ) : (
                <span className="n">{item.nombre}</span>
              )}
              <span className="s mono">{item.sku}</span>
              {item.producto === null ? (
                <span className="etq etq-critico item-pedido-fuera">Ya no esta en el catalogo</span>
              ) : null}
            </div>
            <div className="item-pedido-montos">
              <span className="s">
                {numero(item.cantidad)} x {pesos(item.precioUnitario)}
              </span>
              <span className="num">{pesos(item.subtotal)}</span>
            </div>
          </li>
        ))}
      </ul>

      <dl className="totales-pedido">
        <div>
          <dt>Subtotal</dt>
          <dd className="num">{pesos(pedido.subtotal)}</dd>
        </div>
        <div>
          <dt>{textoEntrega(pedido.tipoEntrega)}</dt>
          {/* A coordinar no es gratis: se cobra aparte, por telefono. */}
          <dd className="num">
            {pedido.tipoEntrega === 'coordinar'
              ? 'Aparte'
              : pedido.costoDespacho > 0
                ? pesos(pedido.costoDespacho)
                : 'Gratis'}
          </dd>
        </div>
        <div className="total">
          <dt>Total</dt>
          <dd className="num">{pesos(pedido.total)}</dd>
        </div>
      </dl>
    </>
  );
}
